export const ROLE_HEADER = 'Role'



// WEBPACK FOOTER //
// ./src/components/AddUserModalSelectRole/constants.js